import { JSEncrypt } from '@tencent/jsencrypt-vb';

/**
 * 使用内置的 RSA 公钥对文本进行加密
 * @param text
 * @returns
 */
export function encryptText(text: string): string {
  const encrypt = new JSEncrypt({
    default_key_size: '1024',
  });

  encrypt.setPublicKey(`-----BEGIN PUBLIC KEY-----
  MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDLZtaoY3x2wFNM7wU3F2thqcsY
  DbecX/39JWLCtIzIxfrMct1CFrEIViePUeAedzw33vAM2oLkSg/Ea9P4TUfx2cIq
  fpQDMhnF9Lho4Ocudxi16DXAOxKT66eti0PRlLHEFB8i5NAqcU7pv8k3rpI+YHZB
  vIAptE/IrdVMzAqQWwIDAQAB
  -----END PUBLIC KEY-----`);

  const encrypted = encrypt.encrypt(text);

  if (!encrypted) {
    throw new Error('encryptText fail');
  }

  return encrypted;
}

export function updateQueryStringParameter(uri: string, key: string, value: string): string {
  if (!value) {
    return uri;
  }
  const re = new RegExp(`([?&])${key}=.*?(&|$)`, 'i');
  const separator = uri.indexOf('?') !== -1 ? '&' : '?';
  if (uri.match(re)) {
    return uri.replace(re, `$1${key}=${value}$2`);
  }

  return `${uri + separator + key}=${value}`;
}
